export default function DubLogo({ className = "h-6" }) {
  return (
    <img 
      src="/dub-logo.svg" 
      alt="dub" 
      className={className}
    />
  )
}
